(function ($) {
    var arrow_next =
        '<div class="slick-arrow-container slick-arrow-container-next"><button type="button" class="slick-next">Next</button></div>';
    var arrow_prev =
        '<div class="slick-arrow-container slick-arrow-container-prev"><button type="button" class="slick-prev">Previous</button></div>';

    $('.ctf-tweet-items').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        dots: true,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 560,
                settings: {
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        slidesToShow: 3,
        slidesToScroll: 3,
        speed: 750,
    });

    $('.m-flexible-logos-carousel__slides').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 6000,
        dots: false,
        nextArrow: arrow_next,
        pauseOnHover: false,
        prevArrow: arrow_prev,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        slide: 'div',
        slidesToScroll: 1,
        slidesToShow: 6,
        speed: 750,
    });

    $('.m-front-page-new__slides').slick({
        arrows: true,
        dots: false,
        focusOnSelect: true,
        nextArrow: arrow_next,
        prevArrow: arrow_prev,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    dots: false,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    dots: false,
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 560,
                settings: {
                    dots: false,
                    slidesToShow: 1,
                },
            },
        ],
        slidesToShow: 3,
    });
    $('.m-front-page-new__control button').bind('click', function () {
        $('.m-front-page-new__button').removeClass('is-active');
        $(this).addClass('is-active');
        target = $(this).attr('data-target');
        slideIndex = parseInt(
            $(target).closest('.slick-slide').data('slick-index')
        );
        $('.m-front-page-new__slides').slick('slickGoTo', slideIndex, false);
    });

    $('.m-hero-front__items').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        pauseOnHover: true,
        slide: 'div',
        speed: 2000,
        fade: true,
    });
})(jQuery);
